import { Injectable, signal } from '@angular/core';

import { GoogleMapsApi } from '@website-builder/application/model/iframe/google-maps-api.type';

@Injectable({ providedIn: 'root' })
export class IframeContextService {
  #window = signal<Window | null>(null);
  #document = signal<Document | null>(null);
  #google = signal<GoogleMapsApi | null>(null);
  #iframeState = signal<HTMLIFrameElement | null>(null);

  readonly window = this.#window.asReadonly();
  readonly document = this.#document.asReadonly();
  readonly google = this.#google.asReadonly();
  readonly iframeState = this.#iframeState.asReadonly();

  connect(iframe: HTMLIFrameElement): void {
    this.#iframeState.set(iframe);
    this.#window.set(iframe.contentWindow);
    this.#document.set(iframe.contentDocument);

    if (iframe.contentWindow['google']) {
      this.#google.set(iframe.contentWindow['google']);
    }
  }

  refreshGoogle(): void {
    const win = this.#window();

    if (!win || !win['google']) {
      return;
    }

    this.#google.set(win['google']);
  }

  clearState(): void {
    this.#window.set(null);
    this.#document.set(null);
    this.#google.set(null);
  }
}
